import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'app/services/user.service';
import moment, { Moment } from 'moment';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-registration-progress',
  templateUrl: './registration-progress.component.html',
  styleUrls: ['./registration-progress.component.scss']
})
export class RegistrationProgressComponent implements OnInit, OnDestroy {

  registrationId: string = '';
  registrationCheckInterval: any = null;
  remainingTimeInterval: any = null;

  startTime: Moment = null;
  remainingTime: string = '';
  elapsedSeconds: number = 0;
  totalRegistrationSeconds: number = 3 * 60;

  isReady: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private userService: UserService,
              private router: Router, private toastService: ToastService) { }

  ngOnInit(): void {
    this.registrationId = this.activatedRoute.snapshot.params.registrationid;

    let checkProgress: any = () => {
      this.userService.registrationStatus(this.registrationId).subscribe((r) => {
        if (r.status == 'ready') {
          this.toastService.success('Account is Ready!');
          this.router.navigate(['/login']);
        } else {
          this.startTime = moment(r.since);
        }
      });
    };
    checkProgress();
    this.registrationCheckInterval = setInterval(checkProgress, 10000);

    this.remainingTimeInterval = setInterval(() => {
      if (this.startTime) {
        let duration: moment.Duration = moment.duration(this.totalRegistrationSeconds * 1000 - moment().diff(this.startTime));
        this.remainingTime = (duration.minutes() > 0)? `${duration.minutes()} minute(s) ${duration.seconds()} seconds`: `${duration.seconds() > 0?duration.seconds(): 0} seconds`;
        this.elapsedSeconds = Math.min(Math.max(this.totalRegistrationSeconds - duration.asSeconds(), 0), this.totalRegistrationSeconds);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.registrationCheckInterval) {
      clearInterval(this.registrationCheckInterval);
    }

    if (this.remainingTimeInterval) {
      clearInterval(this.remainingTimeInterval);
    }
  }

}
